import script from "./B2BProductDetailTile.vue?vue&type=script&lang=ts&setup=true"
export * from "./B2BProductDetailTile.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__